import { AuthXInterceptor } from '../Config/AuthXInterceptor'
import { SortOrder } from '../Model/bnpmPromoXModel'

export interface UpdateBnpmPromoConfigPayload {
  isActive: boolean
  winProbability: number
  firstWinCapMajor: number
  winPercentage: number
  subsequentWinCapMajor: number
  maxWinsInWindow: number
  windowSize: number
  campaignBudgetMajor: number
  endsAt: string
  referrerCutPercentage: number
}

export interface IndexBnpmPromoWinsParams {
  page?: number
  limit?: number
  sortOrder?: SortOrder
  userResourceId?: string
  startDateYYYY_MM_DD?: string
  endDateYYYY_MM_DD?: string
}

export const bnpmPromoBXService = {
  getConfig: async () => {
    return AuthXInterceptor.get('bnpm-promo/config')
  },

  updateConfig: async (payload: UpdateBnpmPromoConfigPayload) => {
    return AuthXInterceptor.put('bnpm-promo/config', payload)
  },

  indexWins: async (params?: IndexBnpmPromoWinsParams) => {
    return AuthXInterceptor.get('bnpm-promo/wins', {
      params,
    })
  },

  showWin: async (id: string) => {
    return AuthXInterceptor.get(`bnpm-promo/wins/${id}`)
  },
}
